import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import DraggableIcon from './DraggableIcon';

const Product = (props) => {
  const draggableId = 'draggable-' + props.id;
  const index = parseInt(props.index);
  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided, snapshot) => (
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className="icon-container slds-grid"
        >
          <div className="slds-grid slds-size_1-of-1 slds-grid_vertical-align-center">
            <DraggableIcon
              productTitle={props.productTitle}
              id={props.id}
              size={props.size}
              category={props.category}
            />
            <div
              className="slds-m-left_xx-small slds-text_heading-small slds-truncate"
              style={{ hyphens: 'auto' }}
            >
              {props.productTitle}
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
};

Product.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  size: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  productTitle: PropTypes.string.isRequired,
};

export default Product;
